import { ContextualError } from "./ContextualError";

/**
 * Invariant assertion for runtime checking of non-undefined values.
 *
 * @example
 * const { experimentId } = useParams<{ experimentId: string }>();
 * invariant<ExperimentId>(experimentId);
 *
 * @example
 * invariant(parameter, "Parameter not found", { parameter_id: param.id });
 */
export default function invariant<T>(
  value: T | undefined | null,
  message = "invariant value required",
  context?: Record<string, unknown>
): asserts value is T {
  if (value === undefined || value === null) {
    throw context ? new ContextualError(message, context) : new Error(message);
  }
}
